/**
 * Utility functions for handling redirect URIs in navigation
 */

export const getRedirectParam = (searchParams: URLSearchParams): string | null => {
  return searchParams.get('redirect');
};

export const addRedirectToUrl = (url: string, currentPath: string): string => {
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.set('redirect', currentPath);
  return urlObj.pathname + urlObj.search;
};

export const navigateWithRedirect = (navigate: (path: string) => void, defaultPath: string, searchParams?: URLSearchParams) => {
  const redirectPath = searchParams ? getRedirectParam(searchParams) : null;
  navigate(redirectPath || defaultPath);
};

export const useRedirectNavigation = () => {
  const navigate = (path: string) => {
    // This will be replaced by the actual navigate function when used
    window.location.href = path;
  };
  
  return {
    navigateBack: (defaultPath: string, searchParams?: URLSearchParams) => {
      navigateWithRedirect(navigate, defaultPath, searchParams);
    },
    addRedirect: (url: string, currentPath: string) => {
      return addRedirectToUrl(url, currentPath);
    }
  };
};